import { useState } from 'react';

import { useCastTypeOptions } from './useCastTypeOptions';
import { CastType, ClientDataType, FieldType } from '../../../../types';
import { useQueryStateContext } from '../../../../contexts';
import { useVisualComponentsContext } from '../../../../contexts/visualComponents';
import { useTranslation } from '../../../../hooks/useTranslation';
import { useOnCastTypeChange } from './hooks/useOnCastTypeChange';

type CastTypeSelectProps = {
  value: CastType | null;
  onChange: (value: CastType | null) => void;
  isInvalid?: boolean;
  dataType: ClientDataType;
  field: string;
  fieldType: FieldType;
};

export const CastTypeSelect = ({
  onChange,
  value,
  isInvalid,
  dataType,
  field,
  fieldType,
}: CastTypeSelectProps) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');
  const options = useCastTypeOptions({ search });
  const { isReadOnly } = useQueryStateContext();
  const { ConditionCastTypeSelect: VisualComponent } = useVisualComponentsContext();
  const onCastTypeChange = useOnCastTypeChange(onChange);

  return (
    <VisualComponent
      dataType={dataType}
      field={field}
      fieldType={fieldType}
      hasError={!!isInvalid}
      isDisabled={!!isReadOnly}
      search={search}
      setSearch={setSearch}
      onChange={onCastTypeChange}
      options={options}
      value={value}
      placeholder={t('v2.conditionBuilder.longCastType.placeholder')}
    />
  );
};
